export const API_DOMAIN = process.env.REACT_APP_DEPLOY === 'true' ?
  '' :
  process.env.REACT_APP_API_DOMAIN || '';
export const GMAPS_API_KEY = process.env.REACT_APP_GMAPS_API_KEY;
export const GMAPS_DEFAULT_ZOOM = 16;
export const API_SOURCE = API_DOMAIN+'/api';
export const DEFAULT_TITLE = 'IT Tick For Web Solutions';
